import { TypographyTheme } from '@kite-js/theme-types';

const typography: TypographyTheme = {
    heading1: {
        textSize: '28px',
        long: '39px',
        short: '28px',
        weight: 'Strong',
    },
    heading2: {
        textSize: '24px',
        long: '34px',
        short: '24px',
        weight: 'Strong',
    },
    heading3: {
        textSize: '20px',
        long: '30px',
        short: '20px',
        weight: 'Strong',
    },
    heading4: {
        textSize: '18px',
        long: '24px',
        short: '18px',
        weight: 'Strong',
    },
    heading5: {
        textSize: '16px',
        long: '24px',
        short: '16px',
        weight: 'Strong',
    },
    subHeading1: {
        textSize: '16px',
        long: '24px',
        short: '16px',
        weight: 'Medium',
    },
    subHeading2: {
        textSize: '16px',
        long: '24px',
        short: '16px',
        weight: 'Normal',
    },
    body1: {
        textSize: '14px',
        long: '20px',
        short: '14px',
        weight: 'Medium',
    },
    body2: {
        textSize: '14px',
        long: '20px',
        short: '14px',
        weight: 'Normal',
    },
    body3: {
        textSize: '12px',
        long: '16px',
        short: '12px',
        weight: 'Strong',
    },
    body4: {
        textSize: '12px',
        long: '16px',
        short: '12px',
        weight: 'Medium',
    },
    caption1: {
        textSize: '12px',
        long: '16px',
        short: '12px',
        weight: 'Strong',
    },
    caption2: {
        textSize: '10px',
        long: '16px',
        short: '10px',
        weight: 'Strong',
    },
    caption3: {
        textSize: '10px',
        long: '16px',
        short: '10px',
        weight: 'Medium',
    },
    pricing1: {
        textSize: '24px',
        long: '34px',
        short: '24px',
        weight: 'Light',
    },
    pricing2: {
        textSize: '20px',
        long: '30px',
        short: '20px',
        weight: 'Strong',
    },
};

export default typography;
